import _typeof from "@babel/runtime/helpers/typeof";
import moment from 'moment';
var THIRTY_MINUTES_IN_MS = 30 * 60 * 1000;
export var minStartTime = function minStartTime() {
  var date = new Date();
  date.setHours(0, 0, 0); // 12:00 AM

  return date;
};
export var minEndTime = function minEndTime(startTime) {
  var startingPoint;
  if (!startTime) {
    startingPoint = minStartTime();
  } else {
    startingPoint = new Date(startTime);
  }

  // whatever startingPoint is, we want to return 30 minutes after it.
  return new Date(startingPoint.getTime() + THIRTY_MINUTES_IN_MS);
};
export var maxEndTime = function maxEndTime() {
  var date = new Date();
  date.setHours(23, 30, 0); // 11:30 PM

  return date;
};
export var maxStartTime = function maxStartTime(endTime) {
  var startingPoint;
  if (!endTime) {
    startingPoint = maxEndTime();
  } else {
    startingPoint = new Date(endTime);
  }

  // whatever startingPoint is, we want to return 30 minutes before it.
  return new Date(startingPoint.getTime() - THIRTY_MINUTES_IN_MS);
};
export var completedAvailabilities = function completedAvailabilities(availabilities) {
  return availabilities.filter(function (a) {
    return a.date && a.start_time && a.end_time;
  });
};
var overlaps = function overlaps(availability1, availability2) {
  if (availability1.date.toDateString() !== availability2.date.toDateString()) {
    return false;
  }
  var a1Start = availability1.start_time.getTime();
  var a1End = availability1.end_time.getTime();
  var a2Start = availability2.start_time.getTime();
  var a2End = availability2.end_time.getTime();
  return Math.max(a1Start, a2Start) <= Math.min(a1End, a2End);
};
export var overlappingAvailabilities = function overlappingAvailabilities(availabilities) {
  var completeAvailabilities = completedAvailabilities(availabilities);
  var overlappingIndices = [];

  // naive O(n^2) implementation - can be done in O(n * logn) but I think for this use-case
  // the performance gain would be minimal.
  // - S.C.
  for (var i = 0; i < completeAvailabilities.length - 1; i += 1) {
    for (var j = i + 1; j < completeAvailabilities.length; j += 1) {
      if (overlaps(completeAvailabilities[i], completeAvailabilities[j])) {
        overlappingIndices.push(i);
        overlappingIndices.push(j);
      }
    }
  }
  return overlappingIndices;
};
export var startTimeInPastValidator = function startTimeInPastValidator(availabilities) {
  var currentTime = new Date();
  for (var i = 0; i < availabilities.length; i += 1) {
    var avail = availabilities[i];
    if (avail.date <= currentTime && avail.start_time && avail.start_time < currentTime) {
      return true;
    }
  }
  return false;
};
var _formatToRubyStyle = function formatToRubyStyle(obj) {
  if (Array.isArray(obj)) return obj.map(_formatToRubyStyle);
  if (obj && _typeof(obj) === 'object') {
    var result = Object.keys(obj).reduce(function (acc, key) {
      var snakeKey = key.replace(/([A-Z])/g, '_$1').toLowerCase();
      var value = obj[key];
      if (snakeKey === 'date') {
        acc.date = value;
      }
      if (snakeKey === 'start_time' && typeof value === 'string') {
        var raw = value.trim();
        var parsed = moment(raw, ['h:mm A', 'hh:mm A', 'h:mmA', 'hh:mmA', 'HH:mm'], true);
        if (parsed.isValid()) {
          acc.start_time = parsed.format('HH:mm');
        }
      }
      return acc;
    }, {});
    if (result.start_time && !result.end_time) {
      result.end_time = moment(result.start_time, 'HH:mm').add(30, 'minutes').format('HH:mm');
    }
    return result;
  }
  return obj;
};
export { _formatToRubyStyle as formatToRubyStyle };
var _formatToJavaScriptStyle = function formatToJavaScriptStyle(obj) {
  if (Array.isArray(obj)) {
    return obj.map(function (item) {
      return _formatToJavaScriptStyle(item);
    });
  }
  if (_typeof(obj) === 'object' && obj !== null) {
    return Object.keys(obj).reduce(function (acc, key) {
      // Convert snake_case to camelCase
      var camelKey = key.replace(/_([a-z])/g, function (_, _char) {
        return _char.toUpperCase();
      });
      var value = obj[key];

      // Only add date and startTime keys to the result object
      if (camelKey === 'date') {
        acc[camelKey] = value;
      } else if (camelKey === 'startTime' && typeof value === 'string' && moment(value, 'HH:mm', true).isValid()) {
        acc[camelKey] = moment(value, 'HH:mm').format('hh:mm A');
      }
      return acc;
    }, {});
  }
  return obj; // Return non-object/non-array values as-is
};
export { _formatToJavaScriptStyle as formatToJavaScriptStyle };